import React from 'react'
import { Box, Typography, Skeleton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useFormFactor } from '../../hooks'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { MobileContentCard } from './mobile-content-card'

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  contentGridContainer: {
    marginBottom: spacing(2),
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },
  carouselWrapper: {
    position: 'relative',
    overflow: 'hidden'
  },
  mobileContentCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: spacing(2),
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    border: 'none',
    height: '360px'
  },
  mobileContentImage: {
    objectFit: 'cover',
    height: '180px',
    [breakpoints.down('md')]: {
      height: '160px'
    },
    [breakpoints.down('sm')]: {
      height: '140px'
    }
  },
  mobileContentCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
    padding: spacing(2),
    flex: 1,
    justifyContent: 'space-between',
    overflow: 'hidden'
  }
}))

export const MobileContentGrid = ({ items, loading, onNavigate }) => {
  const classes = useStyles()
  const { isSmallTablet, isLargeTablet } = useFormFactor()
  const isTablet = isSmallTablet || isLargeTablet

  const mobileCarouselSettings = {
    showArrows: false,
    showStatus: false,
    showThumbs: false,
    showIndicators: false,
    infiniteLoop: false,
    centerMode: true,
    centerSlidePercentage: isTablet ? 60 : 80, //
    emulateTouch: true,
    swipeable: true
  }

  if (loading) {
    mobileCarouselSettings.swipeable = false
    const placeholders = Array.from({ length: 3 })
    return (
      <Box className={classes.contentGridContainer}>
        <Box className={classes.carouselWrapper}>
          <Carousel {...mobileCarouselSettings}>
            {placeholders.map((_, index) => (
              <Box key={`skeleton-${index}`} sx={{ p: 1, minHeight: 340 }}>
                <Box className={classes.mobileContentCard}>
                  <Skeleton variant='rectangular' className={classes.mobileContentImage} />
                  <Box className={classes.mobileContentCardContent}>
                    <Box>
                      <Skeleton variant='text' width='100%' height={30} />
                      <Skeleton variant='text' width='90%' height={20} />
                      <Skeleton variant='text' width='90%' height={20} />
                      <Skeleton variant='text' width='90%' height={20} />
                    </Box>
                    <Skeleton variant='rectangular' height={36} sx={{ borderRadius: '6px' }} />
                  </Box>
                </Box>
              </Box>
            ))}
          </Carousel>
        </Box>
      </Box>
    )
  }

  if (!loading && items.length === 0) {
    return (
      <Box className={classes.emptyState}>
        <Typography variant='body2' color='text.secondary'>No articles found</Typography>
      </Box>
    )
  }

  return (
    <Box className={classes.contentGridContainer}>
      <Box className={classes.carouselWrapper}>
        <Carousel {...mobileCarouselSettings}>
          {items.map((item, index) => (
            <Box key={item.sk || item.locationId || index} sx={{ p: 1, minHeight: 340 }}>
              <MobileContentCard item={item} onNavigate={onNavigate} />
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  )
}
